import { render, staticRenderFns } from "./HeaderGovFederal.vue?vue&type=template&id=1c09b087&"
import script from "./HeaderGovFederal.vue?vue&type=script&lang=js&"
export * from "./HeaderGovFederal.vue?vue&type=script&lang=js&"
import style0 from "./HeaderGovFederal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports